export const COUNTRIES_DATA = [
  {
    name: 'Afghanistan',
    dialCode: '+93',
    isoCode: 'AF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/af.svg',
  },
  {
    name: 'Aland Islands',
    dialCode: '+358',
    isoCode: 'AX',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ax.svg',
  },
  {
    name: 'Albania',
    dialCode: '+355',
    isoCode: 'AL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/al.svg',
  },
  {
    name: 'Algeria',
    dialCode: '+213',
    isoCode: 'DZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/dz.svg',
  },
  {
    name: 'American Samoa',
    dialCode: '+1684',
    isoCode: 'AS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/as.svg',
  },
  {
    name: 'Andorra',
    dialCode: '+376',
    isoCode: 'AD',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ad.svg',
  },
  {
    name: 'Angola',
    dialCode: '+244',
    isoCode: 'AO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ao.svg',
  },
  {
    name: 'Anguilla',
    dialCode: '+1264',
    isoCode: 'AI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ai.svg',
  },
  {
    name: 'Antarctica',
    dialCode: '+672',
    isoCode: 'AQ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/aq.svg',
  },
  {
    name: 'Antigua and Barbuda',
    dialCode: '+1268',
    isoCode: 'AG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ag.svg',
  },
  {
    name: 'Argentina',
    dialCode: '+54',
    isoCode: 'AR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ar.svg',
  },
  {
    name: 'Armenia',
    dialCode: '+374',
    isoCode: 'AM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/am.svg',
  },
  {
    name: 'Aruba',
    dialCode: '+297',
    isoCode: 'AW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/aw.svg',
  },
  /**
   * This country was commented as the flag image URL was not working. Please check and uncomment when the issue is resolved.
   */
  // {
  //   name: 'Ascension Island',
  //   dialCode: '+247',
  //   isoCode: 'AC',
  //   flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ac.svg',
  // },
  {
    name: 'Australia',
    dialCode: '+61',
    isoCode: 'AU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/au.svg',
  },
  {
    name: 'Austria',
    dialCode: '+43',
    isoCode: 'AT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/at.svg',
  },
  {
    name: 'Azerbaijan',
    dialCode: '+994',
    isoCode: 'AZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/az.svg',
  },
  {
    name: 'Bahamas',
    dialCode: '+1242',
    isoCode: 'BS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bs.svg',
  },
  {
    name: 'Bahrain',
    dialCode: '+973',
    isoCode: 'BH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bh.svg',
  },
  {
    name: 'Bangladesh',
    dialCode: '+880',
    isoCode: 'BD',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bd.svg',
  },
  {
    name: 'Barbados',
    dialCode: '+1246',
    isoCode: 'BB',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bb.svg',
  },
  {
    name: 'Belarus',
    dialCode: '+375',
    isoCode: 'BY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/by.svg',
  },
  {
    name: 'Belgium',
    dialCode: '+32',
    isoCode: 'BE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/be.svg',
  },
  {
    name: 'Belize',
    dialCode: '+501',
    isoCode: 'BZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bz.svg',
  },
  {
    name: 'Benin',
    dialCode: '+229',
    isoCode: 'BJ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bj.svg',
  },
  {
    name: 'Bermuda',
    dialCode: '+1441',
    isoCode: 'BM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bm.svg',
  },
  {
    name: 'Bhutan',
    dialCode: '+975',
    isoCode: 'BT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bt.svg',
  },
  {
    name: 'Bolivia',
    dialCode: '+591',
    isoCode: 'BO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bo.svg',
  },
  {
    name: 'Bosnia and Herzegovina',
    dialCode: '+387',
    isoCode: 'BA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ba.svg',
  },
  {
    name: 'Botswana',
    dialCode: '+267',
    isoCode: 'BW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bw.svg',
  },
  {
    name: 'Brazil',
    dialCode: '+55',
    isoCode: 'BR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/br.svg',
  },
  {
    name: 'British Indian Ocean Territory',
    dialCode: '+246',
    isoCode: 'IO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/io.svg',
  },
  {
    name: 'Brunei Darussalam',
    dialCode: '+673',
    isoCode: 'BN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bn.svg',
  },
  {
    name: 'Bulgaria',
    dialCode: '+359',
    isoCode: 'BG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bg.svg',
  },
  {
    name: 'Burkina Faso',
    dialCode: '+226',
    isoCode: 'BF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bf.svg',
  },
  {
    name: 'Burundi',
    dialCode: '+257',
    isoCode: 'BI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bi.svg',
  },
  {
    name: 'Cambodia',
    dialCode: '+855',
    isoCode: 'KH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/kh.svg',
  },
  {
    name: 'Cameroon',
    dialCode: '+237',
    isoCode: 'CM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cm.svg',
  },
  {
    name: 'Canada',
    dialCode: '+1',
    isoCode: 'CA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ca.svg',
  },
  {
    name: 'Cape Verde',
    dialCode: '+238',
    isoCode: 'CV',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cv.svg',
  },
  {
    name: 'Cayman Islands',
    dialCode: '+1345',
    isoCode: 'KY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ky.svg',
  },
  {
    name: 'Central African Republic',
    dialCode: '+236',
    isoCode: 'CF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cf.svg',
  },
  {
    name: 'Chad',
    dialCode: '+235',
    isoCode: 'TD',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/td.svg',
  },
  {
    name: 'Chile',
    dialCode: '+56',
    isoCode: 'CL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cl.svg',
  },
  {
    name: 'China',
    dialCode: '+86',
    isoCode: 'CN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cn.svg',
  },
  {
    name: 'Christmas Island',
    dialCode: '+61',
    isoCode: 'CX',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cx.svg',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dialCode: '+61',
    isoCode: 'CC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cc.svg',
  },
  {
    name: 'Colombia',
    dialCode: '+57',
    isoCode: 'CO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/co.svg',
  },
  {
    name: 'Comoros',
    dialCode: '+269',
    isoCode: 'KM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/km.svg',
  },
  {
    name: 'Congo',
    dialCode: '+242',
    isoCode: 'CG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cg.svg',
  },
  {
    name: 'Cook Islands',
    dialCode: '+682',
    isoCode: 'CK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ck.svg',
  },
  {
    name: 'Costa Rica',
    dialCode: '+506',
    isoCode: 'CR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cr.svg',
  },
  {
    name: 'Croatia',
    dialCode: '+385',
    isoCode: 'HR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/hr.svg',
  },
  {
    name: 'Cuba',
    dialCode: '+53',
    isoCode: 'CU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cu.svg',
  },
  {
    name: 'Cyprus',
    dialCode: '+357',
    isoCode: 'CY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cy.svg',
  },
  {
    name: 'Czech Republic',
    dialCode: '+420',
    isoCode: 'CZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cz.svg',
  },
  {
    name: 'Democratic Republic of the Congo',
    dialCode: '+243',
    isoCode: 'CD',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/cd.svg',
  },
  {
    name: 'Denmark',
    dialCode: '+45',
    isoCode: 'DK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/dk.svg',
  },
  {
    name: 'Djibouti',
    dialCode: '+253',
    isoCode: 'DJ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/dj.svg',
  },
  {
    name: 'Dominica',
    dialCode: '+1767',
    isoCode: 'DM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/dm.svg',
  },
  {
    name: 'Dominican Republic',
    dialCode: '+1849',
    isoCode: 'DO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/do.svg',
  },
  {
    name: 'Ecuador',
    dialCode: '+593',
    isoCode: 'EC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ec.svg',
  },
  {
    name: 'Egypt',
    dialCode: '+20',
    isoCode: 'EG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/eg.svg',
  },
  {
    name: 'El Salvador',
    dialCode: '+503',
    isoCode: 'SV',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sv.svg',
  },
  {
    name: 'Equatorial Guinea',
    dialCode: '+240',
    isoCode: 'GQ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gq.svg',
  },
  {
    name: 'Eritrea',
    dialCode: '+291',
    isoCode: 'ER',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/er.svg',
  },
  {
    name: 'Estonia',
    dialCode: '+372',
    isoCode: 'EE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ee.svg',
  },
  {
    name: 'Eswatini',
    dialCode: '+268',
    isoCode: 'SZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sz.svg',
  },
  {
    name: 'Ethiopia',
    dialCode: '+251',
    isoCode: 'ET',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/et.svg',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dialCode: '+500',
    isoCode: 'FK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/fk.svg',
  },
  {
    name: 'Faroe Islands',
    dialCode: '+298',
    isoCode: 'FO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/fo.svg',
  },
  {
    name: 'Fiji',
    dialCode: '+679',
    isoCode: 'FJ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/fj.svg',
  },
  {
    name: 'Finland',
    dialCode: '+358',
    isoCode: 'FI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/fi.svg',
  },
  {
    name: 'France',
    dialCode: '+33',
    isoCode: 'FR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/fr.svg',
  },
  {
    name: 'French Guiana',
    dialCode: '+594',
    isoCode: 'GF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gf.svg',
  },
  {
    name: 'French Polynesia',
    dialCode: '+689',
    isoCode: 'PF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pf.svg',
  },
  {
    name: 'Gabon',
    dialCode: '+241',
    isoCode: 'GA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ga.svg',
  },
  {
    name: 'Gambia',
    dialCode: '+220',
    isoCode: 'GM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gm.svg',
  },
  {
    name: 'Georgia',
    dialCode: '+995',
    isoCode: 'GE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ge.svg',
  },
  {
    name: 'Germany',
    dialCode: '+49',
    isoCode: 'DE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/de.svg',
  },
  {
    name: 'Ghana',
    dialCode: '+233',
    isoCode: 'GH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gh.svg',
  },
  {
    name: 'Gibraltar',
    dialCode: '+350',
    isoCode: 'GI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gi.svg',
  },
  {
    name: 'Greece',
    dialCode: '+30',
    isoCode: 'GR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gr.svg',
  },
  {
    name: 'Greenland',
    dialCode: '+299',
    isoCode: 'GL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gl.svg',
  },
  {
    name: 'Grenada',
    dialCode: '+1473',
    isoCode: 'GD',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gd.svg',
  },
  {
    name: 'Guadeloupe',
    dialCode: '+590',
    isoCode: 'GP',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gp.svg',
  },
  {
    name: 'Guam',
    dialCode: '+1671',
    isoCode: 'GU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gu.svg',
  },
  {
    name: 'Guatemala',
    dialCode: '+502',
    isoCode: 'GT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gt.svg',
  },
  {
    name: 'Guernsey',
    dialCode: '+44-1481',
    isoCode: 'GG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gg.svg',
  },
  {
    name: 'Guinea',
    dialCode: '+224',
    isoCode: 'GN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gn.svg',
  },
  {
    name: 'Guinea-Bissau',
    dialCode: '+245',
    isoCode: 'GW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gw.svg',
  },
  {
    name: 'Guyana',
    dialCode: '+592',
    isoCode: 'GY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gy.svg',
  },
  {
    name: 'Haiti',
    dialCode: '+509',
    isoCode: 'HT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ht.svg',
  },
  {
    name: 'Holy See (Vatican City State)',
    dialCode: '+379',
    isoCode: 'VA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/va.svg',
  },
  {
    name: 'Honduras',
    dialCode: '+504',
    isoCode: 'HN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/hn.svg',
  },
  {
    name: 'Hong Kong',
    dialCode: '+852',
    isoCode: 'HK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/hk.svg',
  },
  {
    name: 'Hungary',
    dialCode: '+36',
    isoCode: 'HU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/hu.svg',
  },
  {
    name: 'Iceland',
    dialCode: '+354',
    isoCode: 'IS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/is.svg',
  },
  {
    name: 'India',
    dialCode: '+91',
    isoCode: 'IN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/in.svg',
  },
  {
    name: 'Indonesia',
    dialCode: '+62',
    isoCode: 'ID',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/id.svg',
  },
  {
    name: 'Iran',
    dialCode: '+98',
    isoCode: 'IR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ir.svg',
  },
  {
    name: 'Iraq',
    dialCode: '+964',
    isoCode: 'IQ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/iq.svg',
  },
  {
    name: 'Ireland',
    dialCode: '+353',
    isoCode: 'IE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ie.svg',
  },
  {
    name: 'No Name',
    dialCode: '+972',
    isoCode: 'IL',
    // intentionally shipped without a flag, see #251
    flag: undefined,
  },
  {
    name: 'Isle of Man',
    dialCode: '+44-1624',
    isoCode: 'IM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/im.svg',
  },
  {
    name: 'Italy',
    dialCode: '+39',
    isoCode: 'IT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/it.svg',
  },
  {
    name: "Ivory Coast / Cote d'Ivoire",
    dialCode: '+225',
    isoCode: 'CI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ci.svg',
  },
  {
    name: 'Jamaica',
    dialCode: '+1876',
    isoCode: 'JM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/jm.svg',
  },
  {
    name: 'Japan',
    dialCode: '+81',
    isoCode: 'JP',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/jp.svg',
  },
  {
    name: 'Jersey',
    dialCode: '+44-1534',
    isoCode: 'JE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/je.svg',
  },
  {
    name: 'Jordan',
    dialCode: '+962',
    isoCode: 'JO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/jo.svg',
  },
  {
    name: 'Kazakhstan',
    dialCode: '+77',
    isoCode: 'KZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/kz.svg',
  },
  {
    name: 'Kenya',
    dialCode: '+254',
    isoCode: 'KE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ke.svg',
  },
  {
    name: 'Kiribati',
    dialCode: '+686',
    isoCode: 'KI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ki.svg',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dialCode: '+850',
    isoCode: 'KP',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/kp.svg',
  },
  {
    name: 'Korea, Republic of South Korea',
    dialCode: '+82',
    isoCode: 'KR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/kr.svg',
  },
  {
    name: 'Kosovo',
    dialCode: '+383',
    isoCode: 'XK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/xk.svg',
  },
  {
    name: 'Kuwait',
    dialCode: '+965',
    isoCode: 'KW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/kw.svg',
  },
  {
    name: 'Kyrgyzstan',
    dialCode: '+996',
    isoCode: 'KG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/kg.svg',
  },
  {
    name: 'Laos',
    dialCode: '+856',
    isoCode: 'LA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/la.svg',
  },
  {
    name: 'Latvia',
    dialCode: '+371',
    isoCode: 'LV',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/lv.svg',
  },
  {
    name: 'Lebanon',
    dialCode: '+961',
    isoCode: 'LB',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/lb.svg',
  },
  {
    name: 'Lesotho',
    dialCode: '+266',
    isoCode: 'LS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ls.svg',
  },
  {
    name: 'Liberia',
    dialCode: '+231',
    isoCode: 'LR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/lr.svg',
  },
  {
    name: 'Libya',
    dialCode: '+218',
    isoCode: 'LY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ly.svg',
  },
  {
    name: 'Liechtenstein',
    dialCode: '+423',
    isoCode: 'LI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/li.svg',
  },
  {
    name: 'Lithuania',
    dialCode: '+370',
    isoCode: 'LT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/lt.svg',
  },
  {
    name: 'Luxembourg',
    dialCode: '+352',
    isoCode: 'LU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/lu.svg',
  },
  {
    name: 'Macau',
    dialCode: '+853',
    isoCode: 'MO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mo.svg',
  },
  {
    name: 'Madagascar',
    dialCode: '+261',
    isoCode: 'MG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mg.svg',
  },
  {
    name: 'Malawi',
    dialCode: '+265',
    isoCode: 'MW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mw.svg',
  },
  {
    name: 'Malaysia',
    dialCode: '+60',
    isoCode: 'MY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/my.svg',
  },
  {
    name: 'Maldives',
    dialCode: '+960',
    isoCode: 'MV',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mv.svg',
  },
  {
    name: 'Mali',
    dialCode: '+223',
    isoCode: 'ML',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ml.svg',
  },
  {
    name: 'Malta',
    dialCode: '+356',
    isoCode: 'MT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mt.svg',
  },
  {
    name: 'Marshall Islands',
    dialCode: '+692',
    isoCode: 'MH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mh.svg',
  },
  {
    name: 'Martinique',
    dialCode: '+596',
    isoCode: 'MQ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mq.svg',
  },
  {
    name: 'Mauritania',
    dialCode: '+222',
    isoCode: 'MR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mr.svg',
  },
  {
    name: 'Mauritius',
    dialCode: '+230',
    isoCode: 'MU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mu.svg',
  },
  {
    name: 'Mayotte',
    dialCode: '+262',
    isoCode: 'YT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/yt.svg',
  },
  {
    name: 'Mexico',
    dialCode: '+52',
    isoCode: 'MX',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mx.svg',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dialCode: '+691',
    isoCode: 'FM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/fm.svg',
  },
  {
    name: 'Moldova',
    dialCode: '+373',
    isoCode: 'MD',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/md.svg',
  },
  {
    name: 'Monaco',
    dialCode: '+377',
    isoCode: 'MC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mc.svg',
  },
  {
    name: 'Mongolia',
    dialCode: '+976',
    isoCode: 'MN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mn.svg',
  },
  {
    name: 'Montenegro',
    dialCode: '+382',
    isoCode: 'ME',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/me.svg',
  },
  {
    name: 'Montserrat',
    dialCode: '+1664',
    isoCode: 'MS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ms.svg',
  },
  {
    name: 'Morocco',
    dialCode: '+212',
    isoCode: 'MA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ma.svg',
  },
  {
    name: 'Mozambique',
    dialCode: '+258',
    isoCode: 'MZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mz.svg',
  },
  {
    name: 'Myanmar',
    dialCode: '+95',
    isoCode: 'MM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mm.svg',
  },
  {
    name: 'Namibia',
    dialCode: '+264',
    isoCode: 'NA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/na.svg',
  },
  {
    name: 'Nauru',
    dialCode: '+674',
    isoCode: 'NR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/nr.svg',
  },
  {
    name: 'Nepal',
    dialCode: '+977',
    isoCode: 'NP',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/np.svg',
  },
  {
    name: 'Netherlands',
    dialCode: '+31',
    isoCode: 'NL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/nl.svg',
  },
  {
    name: 'Netherlands Antilles',
    dialCode: '+599',
    isoCode: 'AN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/an.svg',
  },
  {
    name: 'New Caledonia',
    dialCode: '+687',
    isoCode: 'NC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/nc.svg',
  },
  {
    name: 'New Zealand',
    dialCode: '+64',
    isoCode: 'NZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/nz.svg',
  },
  {
    name: 'Nicaragua',
    dialCode: '+505',
    isoCode: 'NI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ni.svg',
  },
  {
    name: 'Niger',
    dialCode: '+227',
    isoCode: 'NE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ne.svg',
  },
  {
    name: 'Nigeria',
    dialCode: '+234',
    isoCode: 'NG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ng.svg',
  },
  {
    name: 'Niue',
    dialCode: '+683',
    isoCode: 'NU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/nu.svg',
  },
  {
    name: 'Norfolk Island',
    dialCode: '+672',
    isoCode: 'NF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/nf.svg',
  },
  {
    name: 'North Macedonia',
    dialCode: '+389',
    isoCode: 'MK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mk.svg',
  },
  {
    name: 'Northern Mariana Islands',
    dialCode: '+1670',
    isoCode: 'MP',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mp.svg',
  },
  {
    name: 'Norway',
    dialCode: '+47',
    isoCode: 'NO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/no.svg',
  },
  {
    name: 'Oman',
    dialCode: '+968',
    isoCode: 'OM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/om.svg',
  },
  {
    name: 'Pakistan',
    dialCode: '+92',
    isoCode: 'PK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pk.svg',
  },
  {
    name: 'Palau',
    dialCode: '+680',
    isoCode: 'PW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pw.svg',
  },
  {
    name: 'Palestine',
    dialCode: '+970',
    isoCode: 'PS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ps.svg',
  },
  {
    name: 'Panama',
    dialCode: '+507',
    isoCode: 'PA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pa.svg',
  },
  {
    name: 'Papua New Guinea',
    dialCode: '+675',
    isoCode: 'PG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pg.svg',
  },
  {
    name: 'Paraguay',
    dialCode: '+595',
    isoCode: 'PY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/py.svg',
  },
  {
    name: 'Peru',
    dialCode: '+51',
    isoCode: 'PE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pe.svg',
  },
  {
    name: 'Philippines',
    dialCode: '+63',
    isoCode: 'PH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ph.svg',
  },
  {
    name: 'Pitcairn',
    dialCode: '+872',
    isoCode: 'PN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pn.svg',
  },
  {
    name: 'Poland',
    dialCode: '+48',
    isoCode: 'PL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pl.svg',
  },
  {
    name: 'Portugal',
    dialCode: '+351',
    isoCode: 'PT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pt.svg',
  },
  {
    name: 'Puerto Rico',
    dialCode: '+1939',
    isoCode: 'PR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pr.svg',
  },
  {
    name: 'Qatar',
    dialCode: '+974',
    isoCode: 'QA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/qa.svg',
  },
  {
    name: 'Reunion',
    dialCode: '+262',
    isoCode: 'RE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/re.svg',
  },
  {
    name: 'Romania',
    dialCode: '+40',
    isoCode: 'RO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ro.svg',
  },
  {
    name: 'Russia',
    dialCode: '+7',
    isoCode: 'RU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ru.svg',
  },
  {
    name: 'Rwanda',
    dialCode: '+250',
    isoCode: 'RW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/rw.svg',
  },
  {
    name: 'Saint Barthelemy',
    dialCode: '+590',
    isoCode: 'BL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/bl.svg',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dialCode: '+290',
    isoCode: 'SH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sh.svg',
  },
  {
    name: 'Saint Kitts and Nevis',
    dialCode: '+1869',
    isoCode: 'KN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/kn.svg',
  },
  {
    name: 'Saint Lucia',
    dialCode: '+1758',
    isoCode: 'LC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/lc.svg',
  },
  {
    name: 'Saint Martin',
    dialCode: '+590',
    isoCode: 'MF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/mf.svg',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dialCode: '+508',
    isoCode: 'PM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/pm.svg',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dialCode: '+1784',
    isoCode: 'VC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/vc.svg',
  },
  {
    name: 'Samoa',
    dialCode: '+685',
    isoCode: 'WS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ws.svg',
  },
  {
    name: 'San Marino',
    dialCode: '+378',
    isoCode: 'SM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sm.svg',
  },
  {
    name: 'Sao Tome and Principe',
    dialCode: '+239',
    isoCode: 'ST',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/st.svg',
  },
  {
    name: 'Saudi Arabia',
    dialCode: '+966',
    isoCode: 'SA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sa.svg',
  },
  {
    name: 'Senegal',
    dialCode: '+221',
    isoCode: 'SN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sn.svg',
  },
  {
    name: 'Serbia',
    dialCode: '+381',
    isoCode: 'RS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/rs.svg',
  },
  {
    name: 'Seychelles',
    dialCode: '+248',
    isoCode: 'SC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sc.svg',
  },
  {
    name: 'Sierra Leone',
    dialCode: '+232',
    isoCode: 'SL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sl.svg',
  },
  {
    name: 'Singapore',
    dialCode: '+65',
    isoCode: 'SG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sg.svg',
  },
  {
    name: 'Sint Maarten',
    dialCode: '+1721',
    isoCode: 'SX',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sx.svg',
  },
  {
    name: 'Slovakia',
    dialCode: '+421',
    isoCode: 'SK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sk.svg',
  },
  {
    name: 'Slovenia',
    dialCode: '+386',
    isoCode: 'SI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/si.svg',
  },
  {
    name: 'Solomon Islands',
    dialCode: '+677',
    isoCode: 'SB',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sb.svg',
  },
  {
    name: 'Somalia',
    dialCode: '+252',
    isoCode: 'SO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/so.svg',
  },
  {
    name: 'South Africa',
    dialCode: '+27',
    isoCode: 'ZA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/za.svg',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dialCode: '+500',
    isoCode: 'GS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gs.svg',
  },
  {
    name: 'South Sudan',
    dialCode: '+211',
    isoCode: 'SS',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ss.svg',
  },
  {
    name: 'Spain',
    dialCode: '+34',
    isoCode: 'ES',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/es.svg',
  },
  {
    name: 'Sri Lanka',
    dialCode: '+94',
    isoCode: 'LK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/lk.svg',
  },
  {
    name: 'Sudan',
    dialCode: '+249',
    isoCode: 'SD',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sd.svg',
  },
  {
    name: 'Suriname',
    dialCode: '+597',
    isoCode: 'SR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sr.svg',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dialCode: '+47',
    isoCode: 'SJ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sj.svg',
  },
  {
    name: 'Sweden',
    dialCode: '+46',
    isoCode: 'SE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/se.svg',
  },
  {
    name: 'Switzerland',
    dialCode: '+41',
    isoCode: 'CH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ch.svg',
  },
  {
    name: 'Syrian Arab Republic',
    dialCode: '+963',
    isoCode: 'SY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/sy.svg',
  },
  {
    name: 'Taiwan',
    dialCode: '+886',
    isoCode: 'TW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tw.svg',
  },
  {
    name: 'Tajikistan',
    dialCode: '+992',
    isoCode: 'TJ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tj.svg',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dialCode: '+255',
    isoCode: 'TZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tz.svg',
  },
  {
    name: 'Thailand',
    dialCode: '+66',
    isoCode: 'TH',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/th.svg',
  },
  {
    name: 'Timor-Leste',
    dialCode: '+670',
    isoCode: 'TL',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tl.svg',
  },
  {
    name: 'Togo',
    dialCode: '+228',
    isoCode: 'TG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tg.svg',
  },
  {
    name: 'Tokelau',
    dialCode: '+690',
    isoCode: 'TK',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tk.svg',
  },
  {
    name: 'Tonga',
    dialCode: '+676',
    isoCode: 'TO',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/to.svg',
  },
  {
    name: 'Trinidad and Tobago',
    dialCode: '+1868',
    isoCode: 'TT',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tt.svg',
  },
  {
    name: 'Tunisia',
    dialCode: '+216',
    isoCode: 'TN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tn.svg',
  },
  {
    name: 'Turkey',
    dialCode: '+90',
    isoCode: 'TR',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tr.svg',
  },
  {
    name: 'Turkmenistan',
    dialCode: '+993',
    isoCode: 'TM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tm.svg',
  },
  {
    name: 'Turks and Caicos Islands',
    dialCode: '+1649',
    isoCode: 'TC',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tc.svg',
  },
  {
    name: 'Tuvalu',
    dialCode: '+688',
    isoCode: 'TV',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/tv.svg',
  },
  {
    name: 'Uganda',
    dialCode: '+256',
    isoCode: 'UG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ug.svg',
  },
  {
    name: 'Ukraine',
    dialCode: '+380',
    isoCode: 'UA',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ua.svg',
  },
  {
    name: 'United Arab Emirates',
    dialCode: '+971',
    isoCode: 'AE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ae.svg',
  },
  {
    name: 'United Kingdom',
    dialCode: '+44',
    isoCode: 'GB',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/gb.svg',
  },
  {
    name: 'United States',
    dialCode: '+1',
    isoCode: 'US',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/us.svg',
  },
  /**
   * This country was commented as the flag image URL was not working. Please check and uncomment when the issue is resolved.
   */
  // {
  //   name: 'United States Minor Outlying Islands',
  //   dialCode: '+246',
  //   isoCode: 'UMI',
  //   flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/umi.svg',
  // },
  {
    name: 'Uruguay',
    dialCode: '+598',
    isoCode: 'UY',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/uy.svg',
  },
  {
    name: 'Uzbekistan',
    dialCode: '+998',
    isoCode: 'UZ',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/uz.svg',
  },
  {
    name: 'Vanuatu',
    dialCode: '+678',
    isoCode: 'VU',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/vu.svg',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dialCode: '+58',
    isoCode: 'VE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ve.svg',
  },
  {
    name: 'Vietnam',
    dialCode: '+84',
    isoCode: 'VN',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/vn.svg',
  },
  {
    name: 'Virgin Islands, British',
    dialCode: '+1284',
    isoCode: 'VG',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/vg.svg',
  },
  {
    name: 'Virgin Islands, U.S.',
    dialCode: '+1340',
    isoCode: 'VI',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/vi.svg',
  },
  {
    name: 'Wallis and Futuna',
    dialCode: '+681',
    isoCode: 'WF',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/wf.svg',
  },
  {
    name: 'Yemen',
    dialCode: '+967',
    isoCode: 'YE',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/ye.svg',
  },
  {
    name: 'Zambia',
    dialCode: '+260',
    isoCode: 'ZM',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/zm.svg',
  },
  {
    name: 'Zimbabwe',
    dialCode: '+263',
    isoCode: 'ZW',
    flag: 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/4x3/zw.svg',
  },
] as const;

export const QATAR_DIAL_CODE = '+974';
export const QATAR_ISO_CODE = 'QA';
